import React from "react";
import { Search } from "lucide-react";

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "../../../shadcn/components/ui/input-group";

const TableSearchField = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  ...inputProps
}) => (
  <InputGroup className="w-full md:w-[280px]">
    <InputGroupAddon aria-hidden="true">
      <Search />
    </InputGroupAddon>
    <InputGroupInput
      {...inputProps}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel || placeholder}
    />
  </InputGroup>
);

export default TableSearchField;
